module.exports = __webpack_public_path__ + "img/card2.f5ce20cb.png";